import React, { useEffect } from 'react';
import { usePreferenceContext } from '../../../../context/VideoPreferenceContex';
import { PreferenceSwitch } from './PreferenceSwich';
import styles from './PreferenceSwitch.module.scss';
import { useTranslation } from 'react-i18next';
import CloseButton from '../../../../components/CloseButton/CloseButton';

export const PreferenceList = ({ handleClosePreference, video, updateVideoSettings }) => {
  const {
    canDownload,
    setCanDownload,
    toggleCanDownload,
    canComment,
    setCanComment,
    toggleCanComment,
    canSeeAnalytics,
    setCanSeeAnalytics,
    toggleCanSeeAnalytics,
    canShare,
    setCanShare,
    toggleCanShare,
    disableGIF,
    setDisableGIF,
    toggleDisableGIF,
    shareVideoPlayerOnly,
    setShareVideoPlayerOnly,
    toggleShareVideoPlayerOnly,
    showSidebar,
    setShowSidebar,
    toggleShowSidebar,
    stopSharing,
    setStopSharing,
    updatePreferences,
  } = usePreferenceContext();

  const toggleStopSharing = event => {
    const checked = event.target.checked;
    if (checked === true) {
      // We're toggling the setting to STOP sharing, so show confirmation modal
      handleStopSharing();
    } else {
      setStopSharing(false);
      updatePreferences('stopSharing', false);
    }
  };
  const { t } = useTranslation();

  const list = [
    {
      key: 'canDownload',
      text: t('my_video.tools.preferences.download'),
      isOn: canDownload,
      action: toggleCanDownload,
    },
    {
      key: 'canComment',
      text: t('my_video.tools.preferences.comment'),
      isOn: canComment,
      action: toggleCanComment,
    },
    {
      key: 'canSeeAnalytics',
      text: t('my_video.tools.preferences.analytics'),
      isOn: canSeeAnalytics,
      action: toggleCanSeeAnalytics,
    },
    {
      key: 'canShare',
      text: t('my_video.tools.preferences.share'),
      isOn: canShare,
      action: toggleCanShare,
    },
    {
      key: 'disableGIF',
      text: t('my_video.tools.preferences.gif'),
      isOn: disableGIF,
      action: toggleDisableGIF,
    },
    {
      key: 'shareVideoPlayerOnly',
      text: t('my_video.tools.preferences.share_player_only'),
      isOn: shareVideoPlayerOnly,
      action: toggleShareVideoPlayerOnly,
    },
    {
      key: 'showSidebar',
      text: t('my_video.tools.preferences.show_sidebar'),
      isOn: showSidebar,
      action: toggleShowSidebar,
    },
    {
      key: 'stopSharing',
      text: t('my_video.tools.preferences.stop_sharing'),
      isOn: stopSharing,
      action: toggleStopSharing,
    },
  ];

  useEffect(() => {
    console.log('stopSharing changed', stopSharing);
  }, [stopSharing]);

  // Set all preferences to their correct initial setting
  useEffect(() => {
    if (video.settings) {
      setCanDownload('canDownload' in video.settings ? Boolean(video.settings.canDownload) : true);
      setCanComment('canComment' in video.settings ? Boolean(video.settings.canComment) : false);
      setCanSeeAnalytics('canViewAnalytics' in video.settings ? Boolean(video.settings.canViewAnalytics) : true);
      setCanShare('canShare' in video.settings ? Boolean(video.settings.canShare) : true);
      setDisableGIF('disableGif' in video.settings ? Boolean(video.settings.disableGif) : false);
      setShareVideoPlayerOnly('sharePlayerOnly' in video.settings ? Boolean(video.settings.sharePlayerOnly) : false);
      setShowSidebar('showSidebar' in video.settings ? Boolean(video.settings.showSidebar) : true);
    }
    setStopSharing(!video.active);
  }, [video]);

  useEffect(() => {
    return () => updateVideoSettings();
  }, []);

  const handleStopSharing = () => {
    const confirmSharing = confirm(t('my_video.tools.preferences.stop_sharing.confirm_message'));
    if (confirmSharing) {
      setStopSharing(true);
      updatePreferences('stopSharing', true);
    } else {
      setStopSharing(false);
    }
  };

  return (
    <div className={styles.preferenceContainer}>
      <div className={styles.preferenceHeader}>
        <h2>{t('my_video.tools.video_viewer_settings')} </h2>
        <CloseButton className={styles.closeBtn} onClose={handleClosePreference} />
      </div>
      <div className={styles.listContainer}>
        {list.map(el => {
          if (stopSharing) {
            return el.sharingDependencies ? null : <PreferenceSwitch item={el} key={el.key} />;
          } else {
            return <PreferenceSwitch item={el} key={el.key} />;
          }
        })}
      </div>
    </div>
  );
};
